import { type RealtimeAdapter, socketUrl } from "@luckymenu/staff-core";

/**
 * The live connection on the web: same origin (`/api/ws` through Caddy, or
 * Vite's proxy in development). Reconnects at once when the tab becomes
 * visible again or the browser comes back online.
 */
export function webRealtime(): RealtimeAdapter {
	return {
		url: socketUrl(window.location.origin),
		onWake(listener) {
			const onVisible = () => {
				if (document.visibilityState === "visible") listener();
			};
			document.addEventListener("visibilitychange", onVisible);
			window.addEventListener("online", listener);
			return () => {
				document.removeEventListener("visibilitychange", onVisible);
				window.removeEventListener("online", listener);
			};
		},
	};
}
